import type { ReviewFilters } from "./types";

export const reviewKeys = {
  all: ["reviews"] as const,
  lists: () => [...reviewKeys.all, "list"] as const,
  list: (filters: ReviewFilters) => [...reviewKeys.lists(), filters] as const,
  canReview: (productId: string) => [...reviewKeys.all, "canReview", productId] as const,
};
